module.exports = __webpack_public_path__ + "09fd1cc7aeef5f9098707b3446a082cb.woff";